"use client";

import * as React from "react";

type PortalContainer = Element | DocumentFragment | null;

const ScopedThemePortalContext = React.createContext<PortalContainer>(null);

/**
 * Keeps Radix portals inside a nested theme boundary.
 *
 * Dashboard overlays still portal to <body> because the default context is
 * null. Public VirtualSpace pages mount this provider inside their scoped
 * light/dark shell, so dialogs, menus, selects, popovers, sheets, and tooltips
 * inherit the same tokens as the trigger instead of leaking the host theme.
 */
export function ScopedThemePortalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [container, setContainer] = React.useState<HTMLDivElement | null>(null);

  return (
    <ScopedThemePortalContext.Provider value={container}>
      {children}
      <div
        ref={setContainer}
        className="contents"
        data-vs-theme-portal-host=""
      />
    </ScopedThemePortalContext.Provider>
  );
}

export function useScopedThemePortalContainer(): PortalContainer {
  return React.useContext(ScopedThemePortalContext);
}
